import React, { ReactNode } from "react";

import { DialogTitle, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import BNBox from "../BNBox/BNBox";
import { useLinkDecorationSx } from "../FormElements/BNButton/BNButton";
import { sxEnsureArray } from "../../Helpers/sxMerge";

interface BNDialogHeaderProps {
  onClose: () => void;
  ariaLabel?: string;
  title?: ReactNode;
  showCloseButton: boolean;
  closeButtonText?: ReactNode;
}

export const BNModalHeader: React.FC<BNDialogHeaderProps> = ({
  onClose,
  ariaLabel,
  title,
  showCloseButton = true,
  closeButtonText,
}) => {
  const linkDecoration = useLinkDecorationSx();
  return (
    <>
      {title && <DialogTitle sx={{ mr: 6 }}>{title}</DialogTitle>}
      {showCloseButton && (
        <IconButton
          aria-label={ariaLabel ? ariaLabel : "Close"}
          onClick={onClose}
          size="large"
          sx={{
            position: "absolute !important",
            right: 4,
            top: 4,
            color: "text.primary",
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
          data-uit="close-dialog"
        >
          {closeButtonText && (
            <BNBox
              component="span"
              sx={[
                { typography: "button", fontSize: "1.3rem", textTransform: "initial" },
                ...sxEnsureArray(linkDecoration),
              ]}
            >
              {closeButtonText}
            </BNBox>
          )}
          <Close />
        </IconButton>
      )}
    </>
  );
};
